/**
 * 로그인/유저 API 응답에서 약관 확인 필드를 꺼내 스토어용으로 통일합니다.
 * (camelCase · snake_case · user/profile/data 중첩 지원)
 */

function parseTimestampLike(value) {
  if (value == null || value === "") {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "object" && typeof value.toDate === "function") {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "object" && typeof value.seconds === "number") {
    const ms =
      value.seconds * 1000 +
      Math.floor((value.nanoseconds || 0) / 1_000_000);
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function extractRawTermsAck(userData) {
  if (!userData || typeof userData !== "object") {
    return { rawV: null, rawAt: null };
  }
  const layers = [
    userData,
    userData.user,
    userData.profile,
    userData.data,
  ].filter((x) => x && typeof x === "object" && !Array.isArray(x));

  for (const obj of layers) {
    const v =
      obj.termsNoticeConfirmedVersion ??
      obj.terms_notice_confirmed_version;
    const a =
      obj.termsNoticeConfirmedAt ?? obj.terms_notice_confirmed_at;
    const vDefined = v != null && String(v).trim() !== "";
    const aDefined = a != null && String(a).trim() !== "";
    if (vDefined || aDefined) {
      return { rawV: vDefined ? v : null, rawAt: aDefined ? a : null };
    }
  }
  return { rawV: null, rawAt: null };
}

/**
 * @param {object|null|undefined} userData
 * @returns {{ termsNoticeConfirmedVersion: string|null, termsNoticeConfirmedAt: string|null }}
 */
export function normalizeTermsAckFromPayload(userData) {
  const { rawV, rawAt } = extractRawTermsAck(userData);
  const termsNoticeConfirmedVersion =
    rawV != null && String(rawV).trim() !== ""
      ? String(rawV).trim()
      : null;
  const atDate = parseTimestampLike(rawAt);
  const termsNoticeConfirmedAt = atDate ? atDate.toISOString() : null;
  return { termsNoticeConfirmedVersion, termsNoticeConfirmedAt };
}
